<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="600px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja Adresu
                </h1>
            </v-card-title>
            <v-card-text>
                <v-container class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="delivery.companyName"
                                label="Nazwa firmy"
                                outlined
                                dense
                                :error-messages="companyNameErrors"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="delivery.firstName"
                                label="Imię"
                                outlined
                                dense
                                :error-messages="firstNameErrors"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="delivery.lastName"
                                label="Nazwisko"
                                outlined
                                dense
                                :error-messages="lastNameErrors"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                v-model="delivery.street"
                                label="Ulica"
                                outlined
                                dense
                                :error-messages="streetErrors"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="delivery.zipCode"
                                label="Kod pocztowy"
                                outlined
                                dense
                                :error-messages="zipCodeErrors"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field
                                v-model="delivery.city"
                                label="Miasto"
                                outlined
                                dense
                                :error-messages="cityErrors"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                v-model="delivery.quantity"
                                v-mask="'#######'"
                                type="number"
                                label="Nakład"
                                outlined
                                dense
                                :error-messages="quantityErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer, between } from 'vuelidate/lib/validators'
export default {
    name: 'DeliveryDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        deliveryData: {
            type: Object,
            default: () => {}
        },
        orderDeliveries: {
            type: Array,
            default: () => []
        },
        orderQuantity: {
            type: Number,
            default: null
        },
        actionLoading: {
            type: Boolean,
        }
    },
    data() {
        return {
            delivery: {
                companyName: null,
                firstName: null,
                lastName: null,
                street: null,
                zipCode: null,
                city: null,
                quantity: null
            },
        }
    },
    validations() {
        return {
            delivery: {
                companyName: {
                    required
                },
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                street: {
                    required
                },
                zipCode: {
                    required
                },
                city: {
                    required
                },
                quantity: {
                    required,
                    integer,
                    between: between(1, this.quantityToAssign)
                },
            }
        }
    },
    computed:{
        quantityToAssign() {
            const orderDeliveriesTotalAmount = this.orderDeliveries.reduce((total, deliveryItem) => {
                if (deliveryItem.id !== this.deliveryData.id ) {
                    return total + (deliveryItem.quantity)
                }

                return total
            }, 0)

            return this.orderQuantity - orderDeliveriesTotalAmount
        },
        companyNameErrors() {
            const errors = []

            if (!this.$v.delivery.companyName.$dirty) return errors
            !this.$v.delivery.companyName.required && errors.push('Proszę podać nazwę firmy.')

            return errors
        },
        firstNameErrors() {
            const errors = []

            if (!this.$v.delivery.firstName.$dirty) return errors
            !this.$v.delivery.firstName.required && errors.push('Proszę podać imię.')

            return errors
        },
        lastNameErrors() {
            const errors = []

            if (!this.$v.delivery.lastName.$dirty) return errors
            !this.$v.delivery.lastName.required && errors.push('Proszę podać nazwisko.')

            return errors
        },
        streetErrors() {
            const errors = []

            if (!this.$v.delivery.street.$dirty) return errors
            !this.$v.delivery.street.required && errors.push('Proszę podać ulicę.')

            return errors
        },
        zipCodeErrors() {
            const errors = []

            if (!this.$v.delivery.zipCode.$dirty) return errors
            !this.$v.delivery.zipCode.required && errors.push('Proszę podać kod pocztowy.')

            return errors
        },
        cityErrors() {
            const errors = []

            if (!this.$v.delivery.city.$dirty) return errors
            !this.$v.delivery.city.required && errors.push('Proszę podać miasto.')

            return errors

        },
        quantityErrors() {
            const errors = []

            if (!this.$v.delivery.quantity.required) {
                errors.push('Proszę podać nakład.')
            }

            if (!this.$v.delivery.quantity.integer) {
                errors.push('Niepoprawny format.')
            }

            if (!this.$v.delivery.quantity.required || !this.$v.delivery.quantity.between) {
                errors.push(`Proszę podać wartość z zakresu 1-${this.quantityToAssign}`)
            }

            return errors

        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.delivery = JSON.parse(JSON.stringify(this.deliveryData))
            } else {
                setTimeout(() => {
                    this.$v.$reset()
                    this.delivery = {
                        companyName: null,
                        firstName: null,
                        lastName: null,
                        street: null,
                        zipCode: null,
                        city: null,
                        quantity: null
                    }
                }, 500)
            }
        }
    },
    methods: {
        onSave() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.delivery)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>
